import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
} from '@material-ui/core';

import {
    SelectValidator,
    TextValidator,
    ValidatorForm,
} from 'react-material-ui-form-validator';
import { HCE_ESTADOS_PROBLEMAS } from '../../../../../utils/constants';
import { postInformeOftalmologia } from '../../../../../actions/hce/hceActions';
import { startAlerta } from '../../../../../actions/ui/alertas';

export const ModalIngresoInformeOftalmo = (props) => {

    const dispatch = useDispatch();
    const { hce, protocolosOftalmologia } = props;
    const [informeSeleccionado, setInformeSeleccionado] = useState('');
    const [idProblema, setIdProblema] = useState('');
    const [informe, setInforme] = useState('');
    const {
        problemas,
    } = useSelector((state) => state.hce);

    const onSubmitHandler = () => {
        if ( idProblema > 1){
            let data = {
                idProblema: idProblema,
                idInforme: informeSeleccionado.id,
                informe: informe,
                idAgenda: hce.idAgenda,
                idAfiliado: hce.idAfiliado ? hce.idAfiliado : 0 ,
                idAfiliadoExterno: hce.idAfiliadoExterno ? hce.idAfiliadoExterno : 0
              };
      
              dispatch(postInformeOftalmologia(data));
              props.close();
        }
        else {
            dispatch(startAlerta("Debe ingresar un dianostico antes de generar un informe.", "error"))
        }
    };

    const handleChangeInforme = (e) => {
        const informeId = e.target.value;
        const informeSeleccionado = protocolosOftalmologia.find(item => item.id === informeId);
        setInformeSeleccionado(informeSeleccionado);
    };

    useEffect(() => {
        if (informeSeleccionado?.descripcionInforme) {
            let descripcionInforme = informeSeleccionado.descripcionInforme;
            setInforme(descripcionInforme)
        }
    }, [informeSeleccionado?.descripcionInforme]);

    return (
        <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
            <DialogTitle>{props.titulo}</DialogTitle>
            <DialogContent>
                <ValidatorForm onSubmit={onSubmitHandler}>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            {Array.isArray(problemas) && problemas.length > 0 && (
                                <SelectValidator
                                    fullWidth
                                    label="Seleccionar Problema"
                                    name="protocolos"
                                    value={idProblema ? idProblema : ''}
                                    onChange={(e) => setIdProblema(e.target.value)}
                                    validators={['required']}
                                    errorMessages={['Este campo es requerido']}
                                >
                                    {problemas
                                        .filter(item => item.idEstadoProblema === HCE_ESTADOS_PROBLEMAS.ACTIVO && item.fechaPasadoAError === null)
                                        .map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.problema}
                                            </MenuItem>
                                        ))}
                                </SelectValidator>
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <SelectValidator
                                fullWidth
                                label="Seleccionar Protocolo"
                                name="protocolos"
                                value={informeSeleccionado ? informeSeleccionado.id : ''}
                                onChange={handleChangeInforme}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            >
                                {protocolosOftalmologia.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {`${item.nombreInforme}`}
                                    </MenuItem>
                                ))}
                            </SelectValidator>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            {informeSeleccionado && (
                                <TextValidator
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={12}
                                    label="Informe"
                                    name="informe"
                                    value={informe}
                                    onChange={(e) => setInforme(e.target.value)}
                                    disabled={props.disabled}
                                />
                            )}
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            margin: '1rem 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={props.close}>
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={props.disabled}
                            color="primary"
                        >
                            Guardar
                        </Button>
                    </div>
                </ValidatorForm>
            </DialogContent>
        </Dialog>
    )
}
